const useForceUpdate = () => {
  return window.location.reload();
};

export default useForceUpdate;
